import ApplicationResource from "./ApplicationResource";
import glue from "../glue";
export default class AdminSettingsResource extends ApplicationResource {
    constructor() {
        super(...arguments);
        this.id = '';
        this.key = '';
        this.value = '';
        this.secret = false;
        this.website = glue.websites[0].code;
    }
    pk() {
        return this.id;
    }
}
AdminSettingsResource.resource = '/admin/settings';
//# sourceMappingURL=AdminSettingsResource.js.map